/* @flow */
import * as React from 'react';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import type { TranslatorProps } from 'react-i18next';
import { translate } from 'react-i18next';

import Loading from 'components/Loading/Loading';
import PageWrapper from 'components/PageWrapper/PageWrapper';
import FormWrapper from 'components/FormWrapper/FormWrapper';
import FormSection from 'components/FormSection/FormSection';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import type { BlockedEmailDomain } from 'models/BlockedEmailDomains';

import ElectroResponseMessage from '../components/inputs/ElectroResponseMessage';
import ElectroTextField from '../components/inputs/ElectroTextField/ElectroTextField';
import ElectroCheckbox from '../components/inputs/ElectroCheckbox/ElectroCheckbox';
import FormControls from '../components/controls/FormControls/FormControls';

import { makeFields, emailDomainFormFactory } from './setupEmailDomainForm';
import type { Variant } from './setupEmailDomainForm';

export type EmailDomainFormProps = {
  domain?: BlockedEmailDomain,
  variant?: Variant,
};

type InjectedProps = TranslatorProps;

@translate()
@observer
export default class EmailDomainForm extends ComponentWithInjectedProps<
  EmailDomainFormProps,
  {},
  InjectedProps
> {
  @observable localState = {
    responseMessage: '',
    showResponseMessage: false,
    isLoading: false,
    hasSuccess: false,
    hasError: false,
  };

  @computed get form(): Object {
    const { domain, variant } = this.props;
    const domainData = domain || {};
    const fields = makeFields(domainData, this.props.t);

    return emailDomainFormFactory(fields, this.localState, this.props.t, variant, domainData.id);
  }

  render() {
    const { t, variant } = this.props;
    const form = this.form;

    return this.localState.formIsLoading ? (
      <Loading />
    ) : (
      <React.Fragment>
        <PageWrapper isFlex={false}>
          <ElectroResponseMessage localState={this.localState} />
          <FormWrapper form={form}>
            <FormSection form={form} section="domainDetails">
              <ElectroTextField field={form.$('domainDetails.domainName')} />
              <ElectroCheckbox field={form.$('domainDetails.isDisabled')} />
            </FormSection>
            <FormControls
              form={this.form}
              buttonText={
                variant === 'edit' ? t('general:actions.save') : t('general:actions.create')
              }
            />
          </FormWrapper>
        </PageWrapper>
      </React.Fragment>
    );
  }
}
